import { createContext, useContext } from 'react';

// Everything the Settings groups read, in one place.
//
// The groups were carved out of a 1,600-line Settings.jsx on 17 Sep 2026. They
// could have taken props, but that meant a list of twenty-odd names per group
// and a rename in two files every time one changed. A context keeps the move
// mechanical: the state and the handlers still live in SettingsPage exactly as
// before, and each group reads the ones it uses.
//
// It is deliberately NOT a store: nothing here holds state of its own, and
// nothing outside SettingsPage may write to it.
export const SettingsContext = createContext(null);

export function useSettings() {
  const ctx = useContext(SettingsContext);
  // A group rendered outside the provider would otherwise fail later, on a
  // destructure of null, with a stack that names the wrong file.
  if (!ctx) throw new Error('A Settings group was rendered outside SettingsPage.');
  return ctx;
}
